module.exports = __webpack_public_path__ + "static/media/proclamacao-da-republica.7b255bc1.png";